var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityFinanceEntertainment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.952,
    height: 40.979,
    viewBox: "0 0 44.952 40.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "theater",
    transform: "translate(-1 -4.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55436",
    "data-name": "Path 55436",
    d: "M27.878,37.916a20.137,20.137,0,0,1-7.961,12.1,4.417,4.417,0,0,1-3.865.624C11.484,49.242.927,44.065,1,26.185a1.473,1.473,0,0,1,1.929-1.392A23.8,23.8,0,0,0,14,25.7a22.7,22.7,0,0,0,5.141-1.479,20.93,20.93,0,0,0,1.269,4.532,6.281,6.281,0,0,0-3.06,3.857c2.712.957,4.387.921,5.423.406a19.877,19.877,0,0,0,5.1,4.9Z",
    transform: "translate(0 -5.834)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55437",
    "data-name": "Path 55437",
    d: "M9.7,42.376A24,24,0,0,1,7.3,25.97a24.138,24.138,0,0,1-4.373-.988A1.473,1.473,0,0,0,1,26.374C.927,44.254,11.484,49.431,16.052,50.83a4.417,4.417,0,0,0,3.865-.624,19.776,19.776,0,0,0,2.116-1.747c-4.694.6-9.7-2.141-12.332-6.084Z",
    transform: "translate(0 -6.023)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55438",
    "data-name": "Path 55438",
    d: "M25.892,18.774a30.452,30.452,0,0,1,.827-12.717A2.178,2.178,0,0,1,29.952,4.73a23.74,23.74,0,0,0,9.687,3.364A23.839,23.839,0,0,0,49.826,6.941a2.172,2.172,0,0,1,2.857,2c.529,17.082-9.469,22.578-13.87,24.173a4.4,4.4,0,0,1-3.872-.435c-.1-.065-.21-.131-.312-.21a19.877,19.877,0,0,1-5.1-4.9,19.65,19.65,0,0,1-2.364-4.263,20.93,20.93,0,0,1-1.269-4.532Z",
    transform: "translate(-6.751 -0.388)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55439",
    "data-name": "Path 55439",
    d: "M32.4,8.464a3.629,3.629,0,0,1,1.963-1.617A24.5,24.5,0,0,1,29.952,4.73a2.178,2.178,0,0,0-3.234,1.327,30.452,30.452,0,0,0-.827,12.717,20.93,20.93,0,0,0,1.269,4.532,19.65,19.65,0,0,0,2.364,4.263,19.877,19.877,0,0,0,5.1,4.9c.1.08.21.145.312.21a4.4,4.4,0,0,0,3.872.435c.094-.034.194-.073.294-.11C31.481,27.744,27.841,16.935,32.4,8.464Z",
    transform: "translate(-6.751 -0.388)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48187",
    "data-name": "Group 48187",
    transform: "translate(5.256 10.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55441",
    "data-name": "Path 55441",
    d: "M6.87,34c4.735-3,7.736,1.733,7.736,1.733C7.32,41.383,6.87,34,6.87,34Z",
    transform: "translate(-6.87 -18.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55442",
    "data-name": "Path 55442",
    d: "M28.973,34.733c-1.037.515-2.712.551-5.423-.406a6.281,6.281,0,0,1,3.06-3.857A19.65,19.65,0,0,0,28.973,34.733Z",
    transform: "translate(-11.456 -18.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55443",
    "data-name": "Path 55443",
    d: "M26.88,47.3a32.483,32.483,0,0,0-6.656.334A32.411,32.411,0,0,0,13.8,49.419s2.081-5.561,5.713-6.148S26.88,47.3,26.88,47.3Z",
    transform: "translate(-8.775 -21.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55444",
    "data-name": "Path 55444",
    d: "M38.138,17.705c-8.534,3.495-6.99-3.741-6.99-3.741C36.514,12.34,38.138,17.705,38.138,17.705Z",
    transform: "translate(-13.515 -13.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55445",
    "data-name": "Path 55445",
    d: "M46.88,18.8s2.762-4.88,7.642-2.117C54.522,16.679,54.435,24.074,46.88,18.8Z",
    transform: "translate(-17.871 -14.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55446",
    "data-name": "Path 55446",
    d: "M39.986,29.084a37.825,37.825,0,0,0,7.4.08s-4.227,4.713-7.881,4.307-6.75-5.931-6.75-5.931a38.292,38.292,0,0,0,7.236,1.544Z",
    transform: "translate(-13.986 -17.475)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityFinanceEntertainment);
export default __webpack_public_path__ + "static/media/university-finance-entertainment.4744db8f02a6469fc1e2a32894f5c41e.svg";
export { ForwardRef as ReactComponent };